<template>
    <div class="container">
        <header>
            <h1>{{ pageTitle }}</h1>
        </header>

        <div class="tabs">
            <button
                :class="['tab-btn', { active: activeTab === 'filters' }]"
                @click="switchTab('filters')"
            >
                По фильтрам
            </button>
            <button
                :class="['tab-btn', { active: activeTab === 'image' }]"
                @click="switchTab('image')"
            >
                По изображению
            </button>
            <button
                :class="['tab-btn', { active: activeTab === 'processImage' }]"
                @click="switchTab('processImage')"
            >
                Поиск материала по изображению
            </button>
            <button
                :class="['tab-btn', { active: activeTab === 'furnitureRecognition' }]"
                @click="switchTab('furnitureRecognition')"
            >
                Распознавание мебели
            </button>
            <button
                :class="['tab-btn', { active: activeTab === 'transformer' }]"
                @click="switchTab('transformer')"
            >
                Transformer
            </button>
        </div>

        <FilterTab v-if="activeTab === 'filters'" />
        <ImageSearchTab v-else-if="activeTab === 'image'" />
        <ProcessImageTab v-else-if="activeTab === 'processImage'" />
        <FurnitureRecognitionTab v-else-if="activeTab === 'furnitureRecognition'" />
        <TransformerTab v-else-if="activeTab === 'transformer'" />
    </div>
</template>

<script>
    import { ref, watch } from 'vue'
    import { useRoute, useRouter } from 'vue-router'
    import FilterTab from '@/components/FilterTab.vue'
    import ImageSearchTab from '@/components/ImageSearchTab.vue'
    import ProcessImageTab from '@/components/ProcessImageTab'
    import FurnitureRecognitionTab from '@/components/FurnitureRecognitionTab'
    import TransformerTab from '@/components/TransformerTab.vue'

    export default {
        components: {
            FilterTab,
            ImageSearchTab,
            ProcessImageTab,
            FurnitureRecognitionTab,
            TransformerTab,
        },
        setup() {
            const route = useRoute()
            const router = useRouter()
            const activeTab = ref(route.query.tab || 'filters')
            const pageTitle = ref('Поиск планировок')

            const switchTab = tabName => {
                activeTab.value = tabName
                router.replace({ query: { tab: tabName } })
            }

            watch(route, to => {
                if (to.query.tab) {
                    activeTab.value = to.query.tab
                }
            })

            return { activeTab, pageTitle, switchTab }
        }
    }
</script>

<style scoped>
    @import '@/assets/style.css';
</style>
